import type { LegacyChoiceResult } from '@core-api/presentation/types/response';

export const getIdentitiesWithNameFallback = (
  identities: LegacyChoiceResult[] | null,
) => {
  if (!identities) {
    return null;
  }
  return identities.map((identity) => ({
    choiceId: identity.legacyChoiceId,
    participants:
      getParticipantsWithNameFallback(identity.participantIdentities) ?? [],
  }));
};

export const getParticipantsWithNameFallback = (
  participants: LegacyChoiceResult['participantIdentities'] | undefined,
) => {
  if (!participants) {
    return null;
  }
  return participants.map((participant) => ({
    ...participant,
    displayName: participant.displayName || 'unknown',
  }));
};
